import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { LanguageService } from '../../services';

export const acceptLanguageInterceptor: HttpInterceptorFn = (request, next) => {
    const languageService = inject(LanguageService);

    let languages = navigator.languages.map((language) => language);

    // Example of userPreferredLanguage: lt-lt
    const userPreferredLanguage = languageService.getUserPreferredLanguage();

    if (userPreferredLanguage) {
        // Example of userPreferredLanguageShort: lt
        const userPreferredLanguageShort =
            userPreferredLanguage.indexOf('-') > -1 ? userPreferredLanguage.split('-')[0] : userPreferredLanguage;

        // Look up userPreferredLanguage among navigator languages:
        // Example of navigator.languages: ['en-US', 'en', 'lt', 'lv']
        const found = navigator.languages?.find(
            (language) =>
                language.toLowerCase() === userPreferredLanguage.toLowerCase() ||
                language.toLowerCase() === userPreferredLanguageShort.toLowerCase(),
        );

        // Bring userPreferredLanguage to the top
        if (found) {
            languages = navigator.languages.filter((language) => language !== found);
        }
        languages.unshift(userPreferredLanguage);
    }

    const weights: Array<{ language: string; weight: number }> = languages.map((language, index) => ({
        language,
        weight: parseFloat((1 - index * 0.1).toFixed(1)),
    }));

    // Example of acceptLanguage: lt,en-US;q=0.9,en;q=0.8,lv;q=0.7
    const acceptLanguage = weights
        .map((item) => (item.weight < 1 ? item.language + ';q=' + item.weight : item.language))
        .join(',');

    return next(request.clone({ setHeaders: { 'Accept-Language': acceptLanguage } }));
};
